module.exports = __webpack_public_path__ + "img/pdf.218664a8.png";